export const AUTH_COOKIE_NAME = '_pv_at'
export const ADMIN_AUTH_COOKIE_NAME = '_pv_admin_at'
export const AUTHOR_AUTH_COOKIE_NAME = '_pv_author_at'
export const ADMANAGER_AUTH_COOKIE_NAME = '_pv_admanager_at'